export default "__VITE_ASSET__b65b4279__"